import Request from "../Request";

export default class IHKeywordSearch {
  
  static extended(core) {
    core.translationsKS = core.translationsCommon.keywordSearch;
    
    $(core).on('ready', () => {
      
      $('.ih-keyword-search-input').on('input', _.debounce(function(){
        
        core.keywordSearchMode = true;
        core.searchWord = $(this).val();
        
        let spaceStr = /^\s*$/;
        let counter = $('.ih-keyword-search-counter');
        
        $(core).trigger('ihBeforeRequestPlaces', []);
        counter.text(core.translationsKS.searching);
        // core.controller.clearAllSelector();
        
        if ( !spaceStr.test(core.searchWord) ) {
          core.displayKeywordSearchResults(core.searchWord);
        } else {
          core.displayLoading(false);
          core.initKeywordSearchUI();
        }
        
      }, 500));
      
      $('.ih-keyword-search-button').on('click', function () {
        $('#page-list').panel('open');
      });
      
    });
    
  }
  
  /**
   * キーワード検索の結果を、地図マーカと結果リストとして描画する
   *
   * @param keyword
   */
  displayKeywordSearchResults(keyword){
    
    this.requestFacilitiesByKeyword(keyword).then((result) => {
      // キーワード検索実行時は検索メニュー選択を解除する
      const request = new Request({types: []});
      this.controller.clearAllSelector();
      $('.ih-keyword-search-counter').text(result.length + ' ' + this.translationsKS.hits);
      $(this).trigger('ihAfterTransformPlacesResponse', [request, result]);
      $(this).trigger('ihAfterRequestPlaces', [request, result]);
      
      if ( result.length !== 0 ) {
        $('.ih-keyword-result').removeClass('ui-disabled');
      } else {
        $('.ih-keyword-result').addClass('ui-disabled');
      }
      
    });
    
  }
  
  /**
   * キーワードにマッチするデータを持つ施設オブジェクトをリクエストする
   *
   * @param keyword
   * @returns {Promise}
   */
  requestFacilitiesByKeyword(keyword){
    
    let url = '../facet/api/query?query=' + keyword;  // キーワード検索API
    let that = this;
  
    return new Promise((resolve, reject) => {
  
      $.ajax(
        {
          url: url,
          dataType: 'json',
          data: { query: keyword }
        })
      .done((result) => {
        
        result = that.repository.sortResult(result);
        result = _.map(result, that.repository.convertFromFacetResultItem.bind(that.repository));
  
        resolve(result);
        
      })
      .fail((err) => {
        reject(err);
      });
      
    });
    
  }
  
  initKeywordSearchUI(){
    this.keywordSearchMode = false;
    $('.ih-keyword-search-input').val('');
    $('.ih-keyword-search-counter').text('0 ' + this.translationsKS.hits);
    $('.ih-keyword-result').addClass('ui-disabled');
    $(this.options.numberOfResultSelector).text("");
  }
  
}



// WEBPACK FOOTER //
// ./map/js/ih/modules/IHKeywordSearch.js